import Vue from "vue";

const state = {
  userAddresses: [],
  total: 0
};

const getters = {};

const actions = {
  LOAD_USER_ADDRESSES: async function({ commit }, payload) {
    Vue.prototype.$axios
      .get(
        "users/" +
          payload.userId +
          "/addresses?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_USER_ADDRESSES", res.data.userAddresses);
        commit("SET_TOTAL", res.data.meta.total);
      });
  }
};

const mutations = {
  SET_USER_ADDRESSES: function(state, payload) {
    state.userAddresses = payload;
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
